import { render, staticRenderFns } from "./PartnerRegisterCopySearchIframe.vue?vue&type=template&id=7b86989c&"
import script from "./PartnerRegisterCopySearchIframe.vue?vue&type=script&lang=ts&"
export * from "./PartnerRegisterCopySearchIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports